<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <div *ngIf="showSplash" class="app-splash" aria-label="RECOG app">
    <img src="assets/images/logos/logo_4_lemon.svg" alt="RECOG app">
    <span class="brand-text">RECOG era</span>
    <app-splash-text [text]="'UNLOCK_LEARNING' | t" [start]="splashStarted" [playOnce]="true"
      (completed)="finishSplash()"></app-splash-text>
  </div>
</ion-app>
